export default {"src":"/_next/static/media/upload3.e2f7f860.svg","height":50,"width":40};